const en = {
  navbar: {
    drawer: {
      home: 'Dashboard',
      template: 'Templates',
      workflow: 'Workflow Manager',
      inventory: 'Inventory',
      dataModel: 'Data models',
      documentation: 'Documentation',
      credential: 'Credentials',
      project: 'Projects',
      user: 'Users',
      company: 'Companies',
      configuration: 'Configuration',
      macro: 'Macro',
      job: 'Jobs',
      roles: 'Roles',
      apiReference: 'API Reference',
      niko: 'Niko'
    },
    profile: {
      changePassword: 'Change password',
      logout: 'Log out'
    }
  },
  login: {
    headline: 'Sign in',
    components: {
      submit: 'Login'
    },
    form: {
      username: {
        label: 'Username',
        placeholder: 'Enter a username'
      },
      password: {
        label: 'Password',
        placeholder: 'Enter a password'
      },
      rememberMe: {
        label: 'Remember me'
      }
    },
    alert: {
      success: 'Login successfully',
      error: 'Problems trying to login',
      blocked: 'User blocked'
    }
  },
  home: {
    titleTab: 'Entropy',
    labelTopbar: 'Dashboard',
    headline: 'Overview',
    components: {
      kpis: {
        projects: 'Executed projects',
        nodes: 'Nodes configured',
        errors: 'Errors with nodes',
        inventories: 'Inventories',
        services: 'Services models'
      },
      chartLine: {
        title: 'Jobs history',
        firstLabel: 'Success',
        secondLabel: 'Failed'
      },
      pieChart: {
        title: 'Stats',
        subtitle: 'jobs runned'
      },
      notResults: 'Not results found'
    },
    notCorrectDateRange: 'Please select a correct date range'
  },
  templateList: {
    titleTab: 'Templates',
    labelTopbar: 'Templates',
    headline: 'Templates',
    components: {
      titleList: 'Templates summary',
      add: 'New template',
      table: {
        delete: 'Delete this template',
        edit: 'Edit this template',
        run: 'Run this template'
      },
      alert: {
        success: 'Template created successfully',
        putSuccess: 'Template updated successfully',
        deleteSuccess: 'Template deleted successfully',
        error: 'Something went wrong',
        errorJob: 'Error trying to run the template',
        errorJobInventory: 'Cannot run this template because inventory is in use'
      },
    },
    stepper: {
      backButton: 'Back',
      nextButton: 'Next',
      completedButton: 'Create',
      about: {
        label: 'About',
        title: 'Initial configurations',
        secondTitle: 'Options',
      },
      tag: {
        label: 'Tag',
        title: 'Tags configurations',
      },
      notification: {
        label: 'Notifications',
        title: 'Add notifications',
        buttonLabel: 'Add',
        table: {
          title: 'No notification added yet',
          description: 'Select an user and type for add',
          actionDelete: 'Remove this notification',
        },
      },
      polling: {
        label: 'Polling',
        title: 'Add polling',
        buttonLabel: 'Add',
        modal: {
          description: 'Polling type selected: {{ type }}',
          buttonClose: 'Close',
          rangeSubtitle: 'Range',
          multipleSubtitle: 'Options',
          edit: {
            title: 'Edit polling',
            button: 'Save',
          },
          create: {
            title: 'Complete create',
            button: 'Create',
          },
        },
        table: {
          title: 'No polling added yet',
          description: 'Select a type for add',
          actionDelete: 'Remove this polling',
          actionEdit: 'Edit this polling',
        },
      },
    },
    form: {
      name: {
        label: 'Name',
        placeholder: 'Enter template name',
      },
      description: {
        label: 'Description',
        placeholder: 'Enter a description',
      },
      jobType: {
        label: 'Job type',
        helperText: 'Select the way of executing the job',
      },
      project: {
        label: 'Project',
        helperText: 'Select the project to use',
      },
      inventory: {
        label: 'Inventory',
        helperText: 'Selection of the inventory to use',
      },
      playbook: {
        label: 'Playbook',
        helperText: 'Selecting the playbook to use',
      },
      credential: {
        label: 'Credential',
        helperText: 'Selecting the credential to use',
      },
      forks: {
        label: 'Fork',
        helperText:
          'Maximum number of simultaneous and parallel processes to use in the execution of the playbook',
      },
      limit: {
        label: 'Limit',
        placeholder: 'Enter limit',
        helperText:
          'The maximum number of hosts to run on the playbook, within a group',
      },
      levelDetail: {
        label: 'Level detail',
        helperText: 'Detail control in job execution output',
      },
      tagsJob: {
        label: 'Job tags',
        placeholder: 'Enter a job tag',
        helperText:
          'Specification of which tasks, belonging to the playbook, are going to be executed',
      },
      tagsSkip: {
        label: 'Skip tags',
        placeholder: 'Enter a tag to skip',
        helperText:
          'Specification of which tasks, belonging to the playbook, are not going to be executed',
      },
      tags: {
        label: 'Tags',
        placeholder: 'Enter a new tag',
        helperText:
          'Labels of the job, this allows us to be able to describe and recognize within a project',
      },
      timeout: {
        label: 'Timeout',
        helperText:
          'Maximum time (in seconds) that the playbook should run, otherwise it will be aborted. By default the value is 0',
      },
      commandLine: {
        label: 'Command line',
        placeholder: 'Enter a command line',
      },
      showChanges: {
        label: 'Show changes',
        helperText:
          'Allows the visualization, in the output, of the changes made by the playbook',
      },
      consultExecution: {
        label: 'Consult Execution',
        helperText:
          'Enable the execution query at the time of executing the playbook',
      },
      enabledPrivileges: {
        label: 'Enable elevation of privilege',
        helperText:
          "If enabled run the playbook as administrator. Equivalent to using the '- - become'",
      },
      enabledJobs: {
        label: 'Enable concurrent jobs',
        helperText:
          'Enable execution of tasks in parallel in case they are not dependent',
      },
      useCache: {
        label: 'Use event cache',
        helperText: "Enable the 'fact cache' plugin",
      },
      variables: {
        label: 'Additional variables',
        subtitle: '{{count}} lines | {{language}} file',
        helperText:
          "Are 'extra vars' that the playbok will use when executing. JSON format.",
      },
      userProject: {
        label: 'User',
        helperText: 'Users from a project',
      },
      notificationType: {
        label: 'Type',
      },
      pollingVariable: {
        label: 'Variable',
        placeholder: 'Enter a variable name',
      },
      pollingType: {
        label: 'Type',
      },
      pollingDescription: {
        label: 'Description',
        placeholder: 'Enter a description',
      },
      pollingNumberFrom: {
        label: 'From',
        placeholder: 'Range from a number',
      },
      pollingNumberTo: {
        label: 'To',
        placeholder: 'Range to a number',
      },
      pollingOptionValue: {
        label: 'Value',
        placeholder: 'Enter a value',
      },
      pollingOptionDescription: {
        label: 'Description',
        placeholder: 'Enter a description',
      },
    },
  },
  templateCreate: {
    titleTab: 'Create template',
    labelTopbar: 'Templates > Create template',
    headline: 'New Template',
    components: {
      submit: 'Create new template',
      alert: {
        success: 'Template created successfully',
        error: 'Something went wrong',
      },
    },
  },
  templateEdit: {
    titleTab: 'Edit template',
    labelTopbar: 'Templates > Edit workflow',
    headline: 'Update template',
    components: {
      submit: 'Save changes'
    },
  },
  workflowList: {
    titleTab: 'Workflow Manager',
    labelTopbar: 'Workflows',
    headline: 'Workflows',
    components: {
      titleList: 'Workflows summary',
      add: 'New Workflow',
      table: {
        delete: 'Delete this workflow',
        edit: 'Edit this workflow',
        run: 'Run this workflow'
      },
      alert: {
        success: 'Workflow created successfully',
        putSuccess: 'Workflow updated successfully',
        deleteSuccess: 'Workflow deleted',
        error: 'Something went wrong',
        errorJob: 'Error trying to run the workflow'
      },
    },
    stepper: {
      backButton: 'Back',
      nextButton: 'Next',
      completedButton: 'Create',
      about: {
        label: 'About',
        title: 'Details',
      },
      notification: {
        label: 'Notifications',
        title: 'Add notifications',
        buttonLabel: 'Add',
        table: {
          title: 'No notification added yet',
          description: 'Select an user and type for add',
          actionDelete: 'Remove this notification',
        },
      },
      workflow: {
        title: 'Workflow definition',
        buttonLabel: 'Edit tasks',
      },
    },
    form: {
      name: {
        label: 'Name',
        placeholder: 'Enter workflow name',
      },
      description: {
        label: 'Description',
        placeholder: 'Enter a description',
      },
      project: {
        label: 'Project',
        helperText: 'Select the project to use',
      },
      userProject: {
        label: 'User',
        helperText: 'Users from a project',
      },
      notificationType: {
        label: 'Type',
      },
    },
  },
  workflowCreate: {
    titleTab: 'Create workflow',
    labelTopbar: 'Workflows > Create workflow',
    headline: 'New Workflow',
    components: {
      submit: 'Create new workflow'
    },
  },
  workflowEdit: {
    titleTab: 'Edit workflow',
    labelTopbar: 'Workflows > Edit workflow',
    headline: 'Update workflow',
    headlineView: 'workflow',
    components: {
      submit: 'Save changes',
      task: {
        linkModeMessage: "You are in link mode!",
        headline: 'Define tasks',
        legend: 'Legend',
        counter: '{{tasks}} tasks',
        notResults: 'Not tasks defined',
        editLabel: 'Task',
        addLabel: 'Add task',
        linkLabel: 'Link',
        connectionLabel: 'Connection',
        form: {
          editForm: "Edit",
          save: 'Save',
          cancel: 'Cancel',
          delete: 'delete',
          newTab: "Open in",
          confirm: "Confirm changes",
          condition: "Add condition",
          add: {
            type: 'Workflow',
            action: 'Action',
            endEvent: 'End event',
            satisfy: {
              label: "Will sastify?",
              optionAll: "All conditions",
              optionSome: "Some conditions"
            }
          },
          connection: {
            field: {
              label: 'Field',
              placeholder: 'Enter field'
            },
            condition: 'Condition',
            dataType: 'Data type',
            result: {
              label: 'Value result',
              placeholder: 'Enter value'
            },
            conditionSelected: '{{number}} Condition'
          },
          edit: {
            workflow: "Workflow",
            template: "Template"
          }
        }
      }
    },
  },
  inventoryList: {
    titleTab: 'Inventories',
    labelTopbar: 'Inventories',
    headline: 'Inventories',
    hosts: {
      title: 'Hosts',
      button: 'Add',
      create: {
        title: 'Create host',
      },
      edit: {
        title: 'Edit host',
      },
      table: {
        title: 'No hosts added yet',
        description: 'add a new host',
        actionDelete: 'Remove this host',
        columns: {
          name: 'name',
          ip: 'ip'
        },
        actions: {
          edit: 'Edit',
          delete: 'Delete'
        }
      },
      error: {
        hostFound: 'This host was entered',
        hostDelete: 'A group use this host'
      },
    },
    groupHosts: {
      title: 'Group Hosts',
      button: 'Add',
      create: {
        title: 'Create group',
      },
      edit: {
        title: 'Edit group',
      },
      table: {
        title: 'No groups added yet',
        description: 'add a new group',
        actionDelete: 'Remove this group',
        columns: {
          name: 'name',
          hosts: 'hosts'
        },
        actions: {
          edit: 'Edit',
          delete: 'Delete'
        }
      },
      error: {
        groupHostFound: 'This group was entered',
        groupDelete: 'A children use this group'
      },
    },
    childrenGroupHost: {
      title: 'Children Group',
      button: 'Add',
      create: {
        title: 'Create children group',
      },
      edit: {
        title: 'Edit children group',
      },
      table: {
        title: 'No children groups added yet',
        description: 'add a new children group',
        actionDelete: 'Remove this children group',
        columns: {
          name: 'name',
          groups: 'groups'
        },
        actions: {
          edit: 'Edit',
          delete: 'Delete'
        }
      },
      error: {
        childrenGroupHostFound: 'This children group was entered'
      },
    },
    components: {
      titleList: 'Inventories summary',
      add: 'New Inventory',
      table: {
        delete: 'Delete this inventory',
        edit: 'Edit this inventory',
      },
      alert: {
        success: 'Inventory created successfully',
        putSuccess: 'Inventory updated successfully',
        deleteSuccess: 'Inventory deleted',
        error: 'Something went wrong',
      },
    },
    form: {
      title: 'Details',
      titleHost: 'Host configurations',
      name: {
        label: 'Name',
        placeholder: 'Enter inventory name',
      },
      description: {
        label: 'Description',
        placeholder: 'Enter a inventory description'
      },
      company: {
        label: 'Companies',
        helperText: 'Select the company',
      },
      inventoryType: {
        label: 'Type',
        helperText: 'Select the type',
      },
      tags: {
        label: 'Tags',
        placeholder: 'Enter a new tag'
      },
      modalHostName: {
        label: 'Host name',
        placeholder: 'Enter the host name'
      },
      modalGroupName: {
        label: 'Group name',
        placeholder: 'Enter the name'
      },
      modalIpAddress: {
        label: 'Ip address',
        placeholder: 'Enter de ip address'
      },
      modalNetworkType: {
        label: 'Network type',
        placeholder: 'Enter the network type'
      },
      modalIsActive: {
        label: 'Active',
      },
      modalTags: {
        label: 'Tags',
        placeholder: 'Enter a tag',
      },
      variables: {
        label: 'Additional variables',
        subtitle: '{{count}} lines | {{ language }} file',
        helperText: "",
      },
      modalVariables: {
        label: 'Additional variables',
        subtitle: '{{count}} lines | {{ language }} file',
        helperText: "",
      },
      modalGroupDescription: {
        label: 'Group description',
        placeholder: 'Enter the description'
      },
      modalGroupHosts: {
        label: 'Hosts',
      },
      modalChildrenGroupName: {
        label: 'Name',
        placeholder: 'Enter the name'

      },
      modalChildrenGroupDescription: {
        label: 'Description',
        placeholder: 'Enter the description'
      },
      modalChildrenGroupHosts: {
        label: 'Groups'
      },
      //TODO: DELETE THIS PLEASE >:l
      project: {
       label: 'Project',
       helperText: 'Select the project to use',
     },
    },
  },
  inventoryCreate: {
    titleTab: 'Create Inventory',
    labelTopbar: 'Inventories > Create inventory',
    headline: 'New Inventory',
    components: {
      submit: 'Create new Inventory'
    },
  },
  inventoryEdit: {
    titleTab: 'Edit Inventory',
    labelTopbar: 'Inventories > Edit inventory',
    headline: 'Edit Inventory',
    components: {
      submit: 'Edit Inventory'
    },
  },
  dataModelList: {
    titleTab: 'Data models',
    labelTopbar: 'Data models',
    headline: 'Data models',
    components: {
      titleList: 'Data models summary',
      add: 'New data model',
      table: {
        delete: 'Delete this data model',
        edit: 'Edit this data model',
      },
      alert: {
        success: 'Data model created successfully',
        putSuccess: 'Data model updated successfully',
        deleteSuccess: 'Data model deleted',
        error: 'Something went wrong',
      },
    },
    form: {
      title: 'Detail',
      name: {
        label: 'Name',
        placeholder: 'Enter model name',
      },
      project: {
        label: 'Project',
        helperText: 'Select the project to use',
      },
      variables: {
        label: 'Additional variables',
        subtitle: '{{count}} lines | {{ language }} file',
        helperText: "Service data model",
      },
    },
  },
  dataModelCreate: {
    titleTab: 'Create data model',
    labelTopbar: 'Data models > Create data model',
    headline: 'New data model',
    components: {
      submit: 'Create new data model'
    },
  },
  dataModelEdit: {
    titleTab: 'Edit data model',
    labelTopbar: 'Inventories > Edit data model',
    headline: 'Edit data model',
    components: {
      submit: 'Update data model'
    },
  },
  dataModelView: {
    titleTab: 'View data model',
    labelTopbar: 'Inventories > View data model',
    headline: 'View data model',
  },
  documentationList: {
    titleTab: 'Documentation',
    labelTopbar: 'Documentation',
    headline: 'Documentation',
    components: {
      titleList: 'Documentation summary',
      table: {
        view: 'View this document',
      },
    },
    form: {
      title: 'Details',
      name: {
        label: 'Document name'
      },
      document: {
        label: 'File',
        subtitle: '{{count}} lines | JSON file',
      },
    },
  },
  documentView: {
    titleTab: 'View document',
    labelTopbar: 'Documentation > View document',
    headline: 'View document',
  },
  credentialList: {
    titleTab: 'Crendentials',
    labelTopbar: 'Crendentials',
    headline: 'Crendentials',
    components: {
      titleList: 'Crendentials summary',
      add: 'New Credential',
      table: {
        delete: 'Delete this credential',
        edit: 'Edit this credential',
      },
      alert: {
        success: 'Credential created successfully',
        putSuccess: 'Credential updated successfully',
        deleteSuccess: 'Credential deleted',
        error: 'Something went wrong',
      },
      types: {
        network: 'Network',
        machine: 'Machine',
        token: 'Token',
        pem: 'Pem'
      }
    },
    form: {
      title: 'Credential',
      subtitle: 'Detail',
      name: {
        label: 'Name',
        placeholder: 'Enter credential name',
      },
      description: {
        label: 'Description',
        placeholder: 'Enter credential description',
      },
      company: {
        label: 'company',
        helperText: 'company to use the credentials',
      },
      type: {
        label: 'Type',
      },
      tags: {
        label: 'Tags',
        helperText:  'tags to use on credential',
        placeholder: 'tags to use on credential',
      },
      user: {
        label: 'user',
      },
      password: {
        label: 'password',
      },
      enabled: {
        label: 'enabled',
      },
      privateKey: {
        label: 'privateKey',
      },
      token: {
        label: 'token',
      },
      sudo: {
        label: 'sudo',
      },
    },
  },
  credentialCreate: {
    titleTab: 'Create credential',
    labelTopbar: 'Credentials > Create credential',
    headline: 'New Credential',
    components: {
      submit: 'Create new credential'
    },
  },
  credentialEdit: {
    titleTab: 'Edit Credential',
    labelTopbar: 'Credentials > Edit credential',
    headline: 'Edit Credential',
    components: {
      submit: 'Edit Credential'
    },
  },
  projectList: {
    titleTab: 'Projects',
    labelTopbar: 'Projects',
    headline: 'Projects',
    components: {
      titleList: 'Projects summary',
      add: 'New Project',
      table: {
        delete: 'Delete this project',
        edit: 'Edit this project',
        sync: 'Sync project',
      },
      alert: {
        success: 'Project created successfully',
        putSuccess: 'Project updated successfully',
        deleteSuccess: 'Project deleted',
        syncSuccess: 'Sync started successfully',
        error: 'Something went wrong',
      },
    },
    form: {
      title: 'Detail',
      name: {
        label: 'Name',
        placeholder: 'Enter project name',
      },
      description: {
        label: 'Description',
        placeholder: 'Enter project description',
      },
      company: {
        label: 'Company',
        placeholder: ' Select a project',
      },
      scmType: {
        label: 'SCM type',
        placeholder: ' Enter a SCM type',
      },
      folder: {
        label: 'Folder name that have the project',
        placeholder: ' Enter the folder name ',
      },
      scmUrl: {
        label: 'SCM URL',
        placeholder: 'https://github.com/org/repo.git',
      },
      scmBranch: {
        label: 'SCM Branch',
        placeholder: 'HEAD',
      },
      scmRefspec: {
        label: 'SCM Refspec',
        placeholder: '+refs/heads/*:refs/remotes/origin/*',
      },
      credential: {
        label: 'SCM Credential',
      },
      clean: {
        label: 'Clean',
      },
      deleteOnUpdate: {
        label: 'Delete on Update',
      },
      allowBranchOverride: {
        label: 'Allow Branch Override',
      }
    },
  },
  projectCreate: {
    titleTab: 'Create project',
    labelTopbar: 'Projects > Create project',
    headline: 'New Project',
    components: {
      submit: 'Create new project'
    },
  },
  projectEdit: {
    titleTab: 'Edit Project',
    labelTopbar: 'Projects > Edit project',
    headline: 'Edit project',
    components: {
      submit: 'Edit Project'
    },
  },
  userList: {
    titleTab: 'Users',
    labelTopbar: 'Users',
    headline: 'User list',
    components: {
      titleList: 'User summary',
      add: 'New User',
      addRole: 'Add Role',
      table: {
        delete: 'Delete this user',
        edit: 'Edit this user',
      },
      alert: {
        success: 'User created successfully',
        putSuccess: 'User updated successfully',
        deleteSuccess: 'User deleted',
        error: 'Something went wrong',
      },
    },
    form: {
      title: 'Detail',
      subtitle: 'Roles',
      firstname: {
        label: 'Firstname',
        placeholder: 'Enter user name',
      },
      surname: {
        label: 'Surname',
        placeholder: 'Enter user surname',
      },
      username: {
        label: 'Username',
        placeholder: 'Enter user username',
      },
      email: {
        label: 'Email',
        placeholder: 'Enter user email',
      },
      active: {
        label: 'active',
      },
      selectAll: {
        label: 'Seleccionar todos',
      },
      admin: {
        label: 'Administrator',
      },
      password: {
        label: 'Password',
        placeholder: 'Enter user password',
      },
      confirmPassword: {
        label: 'Confirm Password',
        placeholder: 'Confirm password',
      },
      role: {
        label: 'Role',
        placeholder: 'select a role',
      },
      error: {
        role: 'Element already added',
        equalPassword: 'The password is not equal',
      }
    },
  },
  companyList: {
    titleTab: 'Companies',
    labelTopbar: 'Companies',
    headline: 'Companies',
    components: {
      titleList: 'Companies summary',
      add: 'New Company',
      table: {
        delete: 'Delete this company',
        edit: 'Edit this company',
      },
      alert: {
        success: 'Company created successfully',
        putSuccess: 'Company updated successfully',
        deleteSuccess: 'Company deleted',
        error: 'Something went wrong',
      },
    },
    form: {
      title: 'Detail',
      name: {
        label: 'Name',
        placeholder: 'Enter company name',
      },
      description: {
        label: 'Description',
        placeholder: 'Enter company description',
      },
    },
  },
  companyCreate: {
    titleTab: 'Create company',
    labelTopbar: 'Companies > Create company',
    headline: 'New Company',
    components: {
      submit: 'Create new company'
    },
  },
  companyEdit: {
    titleTab: 'Edit Company',
    labelTopbar: 'Companies > Edit company',
    headline: 'Edit Company',
    components: {
      submit: 'Edit Company'
    },
  },
  configuration: {
    titleTab: 'Configurations',
    labelTopbar: 'Configurations',
    headline: 'Configurations',
    components: {
      alert: {
        putSuccess: 'Configuration updated successfully',
        error: 'Something went wrong',
      },
    },
    form: {
      title: 'Detail',
      vault: {
        label: 'Vault Path',
        placeholder: 'Vault Path',
      },
      nepalRunner: {
        label: 'Entropy Runner',
        placeholder: 'Entropy Runner',
      },
      nepalRunnerHttpUrl: {
        label: 'Entropy Runner Http URL',
        placeholder: 'Entropy Runner Http URL',
      },
      ansibleRunerPath: {
        label: 'Ansible Runner Path',
        placeholder: 'Ansible Runner Path',
      },
      ansibleConfig: {
        label: 'Ansible config path',
        placeholder: 'Enter ansible config path'
      },
      threads: {
        label: 'Threads',
        placeholder: 'Enter threads'
      },
      inventoryPath: {
        label: 'Inventory Path',
        placeholder: 'Enter inventory path'
      },
      macrosPlaybookPath: {
        label: 'Macros Playbook Path',
        placeholder: 'Enter macros playbook path'
      },
      macrosPlaybook: {
        label: 'Macros Playbook',
        placeholder: 'Enter macros playbook'
      },
      macrosConfigPath: {
        label: 'Macros Configuration Path',
        placeholder: 'Enter macros configuration path'
      },
      ansibleMongoUrl: {
        label: 'Ansible Mongo URL',
        placeholder: 'Ansible Mongo URL',
      },
      nepalBackendFileEndpoint: {
        label: 'Entropy Backend File Endpoint',
        placeholder: 'Entropy Backend File Endpoint',
      },
      rabitmq: {
        label: 'RabbitMQ',
        placeholder: 'RabbitMQ',
      },
      rabitmqTail: {
        label: 'RabbitMQ Tail',
        placeholder: 'RabbitMQ Tail',
      },
      mailHost: {
        label: 'Mail Host',
        placeholder: 'Mail Host',
      },
      mailPort: {
        label: 'Mail Port',
        placeholder: 'Mail Port',
      },
      mailSecure: {
        label: 'Mail Secure',
        placeholder: 'Mail Secure',
      },
      mailUser: {
        label: 'Mail User',
        placeholder: 'Mail User',
      },
      mailPass: {
        label: 'Mail Pass',
        placeholder: 'Mail Pass',
      },
      mailRejectUnauthorized: {
        label: 'Mail Reject Unauthorized',
        placeholder: 'Mail Reject Unauthorized',
      },
      mailFrom: {
        label: 'Mail From',
        placeholder: 'Mail From',
      },
    },
  },
  configurationEdit: {
    titleTab: 'Edit configuration',
    labelTopbar: 'Configuration > Edit configuration',
    headline: 'Update configuration',
    components: {
      submit: 'Save changes'
    },
  },
  jobList: {
    titleTab: 'Jobs',
    labelTopbar: 'Jobs',
    headline: 'Jobs',
    components: {
      titleList: 'Jobs summary',
      abort: 'Abort all jobs',
      table: {
        stop: 'Abort job running',
        children: 'See all the jobs',
        view: 'View this job',
        tags: {
          template: 'Template',
          workflow: 'Workflow',
        },
        col: {
          type: 'Type'
        },
        delete: 'Delete this job',
        edit: 'Edit this job',
      },
      alert: {
        successAbort: 'Job aborted successfully',
        errorAbort: 'Problems trying to abort the job'
      },
    },
  },
  jobRunTemplate: {
    titleTab: 'Template job',
    labelTopbar: 'Jobs > Template job',
    headline: 'Template job',
    components: {
      title: 'Detail from {{job}}',
      label: {
        status: 'Status',
        created: 'Created',
        start: "Started",
        finish: 'Finished',
        project: 'Project',
        playbok: 'Playbook',
        credential: 'Credential',
        environment: 'Environment',
        logs: 'Log config file'
      }
    },
  },
  jobRunWorkflow: {
    titleTab: 'Workflow job',
    labelTopbar: 'Jobs > Workflow job',
    headline: 'Workflow job',
    editHeadLine: 'Workflow detail',
    components: {
      title: '{{job}}',
      subtitle: 'Detail',
      label: {
        status: 'Status',
        created: 'Created',
        start: "Started",
        finish: 'Finished',
        project: 'Project',
        environment: 'Environment'
      },
      button: {
        stopAll: 'Stop all',
        view: 'View workflow'
      }
    },
  },
  changePassword: {
    titleTab: 'Change Password',
    labelTopbar: 'Change Password',
    headline: 'Change Password',
    components: {
      submit: 'Change Password'
    },
    form: {
      title: 'Change Password',
      oldPassword: 'Old password',
      newPassword: 'New password',
      confirmPassword: 'Confirm password',
      error: {
        equalPassword: 'The password is not equal'
      }
    },
    alert: {
      success: 'Password edited successfully',
      error: 'Problems trying to change password'
    },
  },
  roleList: {
    titleTab: 'Roles',
    labelTopbar: 'Roles',
    headline: 'Roles',
    components: {
      titleList: 'Roles summary',
      add: 'New Role',
      submitPermissionProyect: 'Set Project Permissions',
      table: {
        delete: 'Delete this role',
        edit: 'Edit this role',
      },
      alert: {
        success: 'Role created successfully',
        putSuccess: 'Role updated successfully',
        deleteSuccess: 'Role deleted',
        error: 'Something went wrong',
      },
    },
    form: {
      title: 'Details',
      subtitle: 'Project permissions',
      subtitleGlobal: 'Global permissions',
      name: {
        label: 'Name',
        placeholder: 'Enter role name',
      },
      description: {
        label: 'Description',
        placeholder: 'Enter a description',
      },
      project: {
        label: 'Project',
        helperText: 'Select the project to set permissions',
      },
    }
  },
  roleCreate: {
    titleTab: 'Create role',
    labelTopbar: 'roles > Create role',
    headline: 'New Role',
    components: {
      submit: 'Create new role'
    },
  },
  roleEdit: {
    titleTab: 'Edit Role',
    labelTopbar: 'Roles > Edit role',
    headline: 'Edit Role',
    components: {
      submit: 'Save Role'
    },
  },
  userCreate: {
    titleTab: 'Create user',
    labelTopbar: 'users > Create user',
    headline: 'New user',
    components: {
      submit: 'Create new user'
    },
  },
  userEdit: {
    titleTab: 'Edit user',
    labelTopbar: 'Users > Edit user',
    headline: 'Edit user',
    components: {
      submit: 'Save user'
    },
  },
  macroExecute: {
    labelTopbar: 'Macro',
    titleTab: 'Macro',
  },
  apiTokenList: {
    titleTab: 'API Reference',
    labelTopbar: 'API Reference',
    headline: 'API Reference',
    components: {
      tabs: {
        clients: 'Clients',
        tokens: 'Tokens',
        audit: 'Audit Log',
        documentation: 'Documentation',
      },
      addClient: 'New client',
      addToken: 'New token',
      filterByClient: 'Filter by client',
      clientDialog: {
        title: 'Create API client',
      },
      tokenDialog: {
        title: 'Create access token',
        client: 'Client',
        scopes: 'Scopes',
        scopesHelp: 'Comma-separated, e.g.: jobs.run',
        allowedProjects: 'Allowed projects',
        allowedTemplates: 'Allowed templates',
        expiresDays: 'Expiration (days)',
        idsHelp: 'Comma-separated, e.g.: 1,2,3. Empty = no restriction',
        noRestriction: 'No restriction',
        loadingProjects: 'Loading projects...',
        loadingTemplates: 'Loading templates...',
        projectsHelp: 'Select projects. Empty = all projects allowed',
        templatesHelp: 'Templates available based on the selected projects. If no projects are selected, no templates will be shown.',
        selectProjectFirst: 'Select at least one project to see the templates',
        noTemplatesForProjects: 'No templates available for the selected projects',
      },
      scopes: {
        jobs_run: 'Jobs: Run',
        jobs_read: 'Jobs: Read',
        credentials_read: 'Credentials: Read',
        inventories_read: 'Inventories: Read',
        projects_read: 'Projects: Read',
        templates_read: 'Templates: Read',
      },
      plainTokenDialog: {
        title: 'Token generated',
        warning: 'Copy this token now. It will not be shown again.',
      },
      table: {
        clientsTitle: 'Registered clients',
        tokensTitle: 'Access tokens',
        auditTitle: 'Audit log',
        prefix: 'Prefix',
        client: 'Client',
        scopes: 'Scopes',
        revoked: 'Revoked',
        active: 'Active',
        expired: 'Expired',
        expiresAt: 'Expires',
        lastUsed: 'Last used',
        requestId: 'Request ID',
        method: 'Method',
        path: 'Path',
        status: 'HTTP Status',
        ip: 'IP',
        duration: 'Duration',
      },
      actions: {
        toggle: 'Enable / Disable',
        deleteClient: 'Delete client',
        deleteToken: 'Delete token',
        revoke: 'Revoke token',
      },
      alert: {
        success: 'Operation successful',
        deleteSuccess: 'Deleted successfully',
        revokeSuccess: 'Token revoked',
        error: 'Something went wrong',
      },
      modal: {
        deleteClient: {
          title: 'Delete client?',
          text: 'This will delete the client and all its tokens. This cannot be undone.',
        },
        revokeToken: {
          title: 'Revoke token?',
          text: 'The token will be permanently deactivated.',
        },
        deleteToken: {
          title: 'Delete token?',
          text: 'The token will be hidden from the list and can no longer be used. The audit history is preserved.',
        },
      },
    },
    docs: {
      title: 'External Entropy API',
      urlBase: 'Base URL',
      urlBaseNote: 'Replace host and port with those of the corresponding environment.',
      commonHeaders: 'Common headers',
      statusCodes: 'Status codes',
      endpointsLabel: 'Endpoints',
      th: {
        field: 'Field',
        type: 'Type',
        required: 'Required',
        description: 'Description',
        yes: 'Yes',
        no: 'No',
      },
      statusChip: {
        ok: '200 OK',
        accepted: '202 Accepted',
        unauthorized: '401 Unauthorized',
        forbidden: '403 Forbidden',
        notFound: '404 Not Found',
        conflict: '409 Conflict',
        unprocessable: '422 Invalid Payload',
        rateLimit: '429 Rate Limit',
      },
      scopeLabel: 'Scope: {{scope}}',
      section: {
        headersRequired: 'Required headers',
        body: 'Body',
        example: 'Example request',
        response200: 'Response 200',
        response202: 'Response 202',
        errors: 'Possible errors',
        pathParams: 'Path parameters',
        queryParams: 'Query parameters (all optional)',
        idempotencyTitle: 'Idempotency',
      },
      idempotency: {
        intro: 'The Idempotency-Key header is required for this endpoint. Its purpose is to prevent duplicate jobs from client retries.',
        rule1Prefix: 'Same key + same body:',
        rule1Body: 'the original response is returned without creating a new job. The response includes the header X-Idempotency-Replayed: true.',
        rule2Prefix: 'Same key + different body:',
        rule2Body: '409 idempotency_conflict.',
        rule3Prefix: 'New key + same body:',
        rule3Body: 'a new job is created (independent operation).',
        rule4: 'If your client retries automatically, it must reuse the same key until the response is confirmed.',
      },
      commonHeadersData: {
        auth: { field: 'Authorization', type: 'string', required: 'Yes (except /health)', description: 'Bearer <api_token>. Token delivered when creating the client. Do not log or version.' },
        contentType: { field: 'Content-Type', type: 'string', required: 'Yes (with JSON body)', description: 'application/json (on requests with body).' },
        idempotencyKey: { field: 'Idempotency-Key', type: 'UUID v4', required: 'Yes (only POST /jobs)', description: 'Only POST /jobs. Prevents duplicates on retries.' },
        correlationId: { field: 'X-Correlation-Id', type: 'UUID', required: 'No', description: 'Optional. Persisted in the audit log.' },
      },
      endpoints: {
        health: {
          description: 'Liveness check. No authentication or idempotency-key required.',
        },
        createJob: {
          description: 'Creates and enqueues a job. The template must belong to the submitted project and be in the token\'s allowed_templates.',
          headersData: {
            auth: { field: 'Authorization', type: 'Bearer <api_token>', required: 'Yes', description: '' },
            contentType: { field: 'Content-Type', type: 'application/json', required: 'Yes', description: '' },
            idempotencyKey: { field: 'Idempotency-Key', type: 'UUID v4', required: 'Yes', description: 'Unique per operation' },
          },
          bodyData: {
            worktemplate: { field: 'worktemplate_id', type: 'integer', required: 'Yes', description: 'Template ID. Must be in the token\'s allowed_templates.' },
            project: { field: 'project_id', type: 'integer', required: 'Yes', description: 'Project ID. Must be in the token\'s allowed_projects.' },
            userInteraction: { field: 'userInteraction', type: 'object', required: 'No', description: 'Free-form object. E.g.: { "approval": "AUTO" }' },
            variables: { field: 'variables', type: 'object', required: 'No', description: 'Additional job variables (Ansible extra_vars). Plain object of scalar values. Merged with the work template ones; on a name clash this value wins. E.g. { "vlan": 100 }' },
          },
          errors: {
            '401': 'Invalid, expired, or revoked token.',
            '403': 'Missing scope, project_not_allowed, or template_not_allowed.',
            '404': 'worktemplate_not_found.',
            '409': 'idempotency conflict (same key, different body).',
            '422': 'project_mismatch or invalid payload.',
          },
        },
        listJobs: {
          description: 'Lists jobs respecting the token\'s allowed_projects. Order: created DESC NULLS LAST, job_id DESC.',
          queryParamsData: {
            ids: { field: 'ids', type: 'CSV int', required: 'No', description: 'Filter by job_id. E.g.: ?ids=1,2,3' },
            status: { field: 'status', type: 'string', required: 'No', description: 'Exact status: WA, RU, AB, FI' },
            proyectId: { field: 'proyect_id', type: 'integer', required: 'No', description: 'Filter by project' },
            limit: { field: 'limit', type: 'int (1-500)', required: 'No', description: 'Default 100, truncated to 500' },
            offset: { field: 'offset', type: 'int (>=0)', required: 'No', description: 'Default 0' },
          },
          note: 'The response does not include heavy fields (ex_result, variables, ansible_out, hostresult). For full job detail, use GET /jobs/:jobId.',
          errors: {
            '401': 'Invalid token.',
            '403': 'Missing jobs.read scope.',
            '422': 'Malformed parameters.',
          },
        },
        getJob: {
          description: 'Full job detail.',
          pathParamsData: {
            jobId: { field: 'jobId', type: 'integer', required: 'Yes', description: 'Job ID (positive)' },
          },
          errors: {
            '401': 'Invalid token.',
            '403': 'Missing scope, or job outside allowed_projects.',
            '404': 'Job not found.',
            '422': 'Invalid jobId.',
          },
        },
        getJobStatus: {
          description: 'Job status only (lightweight subset, useful for polling).',
          pathParamsData: {
            jobId: { field: 'jobId', type: 'integer', required: 'Yes', description: 'Job ID (positive)' },
          },
        },
        cancelJob: {
          description: 'Cancels a job in WA or RU state. No body required.',
          pathParamsData: {
            jobId: { field: 'jobId', type: 'integer', required: 'Yes', description: 'Job ID (positive)' },
          },
          errors: {
            '401': 'Invalid token.',
            '403': 'Missing scope, or job outside allowed_projects.',
            '404': 'Job not found.',
            '409': 'job_not_cancellable (the job has already finished or is not in a cancellable state).',
            '422': 'Invalid jobId.',
          },
        },
      },
    },
  },
  macro: {
    titleTab: 'Execute Macro',
    labelTopbar: 'Macro',
    headline: 'Macros',
    components: {
      alert: {
        postSuccess: 'Macro executed successfully',
        error: 'Something went wrong',
      },
      submit: 'execute'
    },
    form: {
      title: 'Detail',
      error: {
        inventory: 'The inventory is required',
        credential: 'The credential is required'
      },
      name: {
        label: 'Name',
        placeholder: 'Enter macro name',
      },
      description: {
        label: 'Description',
        placeholder: 'Enter a description',
      },
      inventory: {
        label: 'Inventory',
        helperText: 'Selection of the inventory to use',
      },
      type: {
        label: 'Type',
        helperText: 'Select the type',
      },
      hosts: {
        label: 'Hosts',
        placeholder: 'Enter host',
        helperText: ''
      },
      credential: {
        label: 'Credential',
        helperText: 'Selecting the credential to use',
      },
      configFile: {
        label: 'Config file',
        helperText: 'Select the config file to use',
      },
    },
  },
  common: {
    status: {
      ok: 'Success',
      er: 'Error',
      ab: 'Skipped',
      ne: 'Aborted',
      wa: 'Waiting',
      ru: 'Running'
    },
    nodesOption: {
      succed: "Succed",
      error: "Error",
      always: "Always",
      condition: "Condition",
      noDependency: "No dependency"
    },
    conditionsOption: {
      equalTo: "(==) equal to" ,
      notEqualTo: "(!=) not equal to",
      greaterThan: "(>) greater than",
      greaterThanOrEqualTo: "(>=) greater than or equal to",
      lessThan: "(<) less than",
      lessThanOrEqualTo: "(<=) less than or equal to"
    },
    dataSelect: {
      notificationType: {
        init: 'Start',
        endSuccess: 'End success',
        endError: 'End error',
        autorize: 'Autorization',
      },
      pollingType: {
        text: 'Text',
        number: 'Number',
        option: 'Multiple options',
      },
      pollingOption: {
        optionOne: 'Option 1',
        optionTwo: 'Option 2',
      },
      levelDetail: {
        normal: 'Normal',
        verbose: 'Verbose',
        moreVerbose: 'MoreVerbose',
        debug: 'Debug',
        connectionDebug: 'ConnectionDebug',
        connectionDebugplus: 'ConnectionDebugplus',
      },
      jobType: {
        eject: 'Execute',
        check: 'Check',
        scan: 'Scan',
      },
    },
    errors: {
      general: {
        title: 'Something went wrong',
        subtitle: 'we encountered an error, while trying to connect with our server.',
        directory: 'Directory doesnt exist'
      },
    },
    components: {
      macroSwichLabel: 'Macros',
      dateToLabel: 'Date to',
      dateFromLabel: 'Date from',
      maximizeLabel: 'Maximize editor',
      renderedView: 'Rendered View',
      codeView: 'Code View',
      importFile: 'Import file',
      exportFile: 'Export file',
      cancelImportFile: 'Cancel import file',
      noDataLabel: 'No data',
      noOptionsText: 'No options',
      footer: {
        title: 'Powered by',
        description: '© Octupus. All rights reserved.'
      },
      alert: {

      },
      dragzone: {
        invalidFormat: 'The file does not have a valid format',
        fileExtension: 'The file need an extension'
      },
      table: {
        titleNotResults: 'No results found.',
        descriptionNotResults: "We can't find any item matching your search.",
        buttonNew: 'Create a new one',
        col: {
          username: 'Username',
          name: 'Name',
          description: 'Description',
          surname: 'Surname',
          rate: 'Success rate',
          jobs: 'Last jobs',
          view: 'View',
          action: 'Actions',
          status: 'Status',
          createdAt: 'Created at'
        }
      },
      chip: {
        edit: 'Edit',
        create: 'Create',
        delete: 'Delete',
        run: 'Run',
        visible: 'Visible',
      },
      search: {
        label: 'What are you looking for?',
        placeholder: 'search',
      },
      project: {
        label: 'Projects',
      },
      buttons: {
        search: 'Search',
        cancel: 'Cancel',
        confirm: 'Confirm',
        save: 'Guardar',
        returnHome: 'Return to home',
        run: 'Run',
        view: 'view Detail',
        create: 'Create',
        close: 'Close'
      },
      chipList: {
        error: 'Element already added',
      },
      modal: {
        label: 'Would you like to continue ?',
      },
      modalJob: {
        label: 'Run a job',
      }
    },
    rules: {
      empty: "None",
      required: 'Required field',
      pattern: 'Invalid input',
      maxLength: 'Limit of max characters',
      minLength: 'Limit of min characters',
      max: 'Max value limit',
      min: 'Min value limit',
      placeholder: 'Enter the field',
      email: 'Invalid email'
    },
    permissionLabels: {
      dasboard: 'Dasboard',
      templates: 'Templates',
      workflow: 'Workflow',
      inventories: 'Inventories',
      dataModels: 'DataModels',
      documentations: 'Documentations',
      credentials: 'Credentials',
      projects: 'Projects',
      users: 'Users',
      companies: 'Companies',
      configuration: 'Configuration',
      jobs: 'Jobs',
      roles: 'Roles',
      macros: 'Macros',
    },
    labels: {
      yes: 'YES',
      no: 'NO'
    },
    all: 'All',
    active: 'Active',
    inactive: 'Inactive',
    copy: 'Copy',
    copied: 'Copied!',
    copyError: 'Copy failed',
    copyFallback: 'Selected · Ctrl+C',
    copyFallbackHint: 'The browser blocked the automatic copy. Select the token manually and copy it with Ctrl+C (or Cmd+C on Mac).',
    required: 'Required field'
  },
  template: {
    stepper: {
      polling: {
        modal:{
          create:{
            button: 'save'
          },
          edit: {
            button: 'Save'
          },
          buttonClose: 'close'
        }
      }
    }
  },
};

export default en;
